// extracted by mini-css-extract-plugin
export var avatarContainer = "_8m-0";
export var avatarTypingWave = "_8m-i";
export var gray = "_8m-f";
export var green = "_8m-c";
export var icon = "_8m-9";
export var image = "_8m-1";
export var lg = "_8m-6";
export var md = "_8m-5";
export var presenceDot = "_8m-b";
export var red = "_8m-d";
export var sm = "_8m-4";
export var status = "_8m-a";
export var typingDot = "_8m-h";
export var typingPill = "_8m-g";
export var xl = "_8m-7";
export var xs = "_8m-3";
export var xxl = "_8m-8";
export var xxs = "_8m-2";
export var yellow = "_8m-e";